import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  selector: 'pplus-table-range-cell-renderer',
  templateUrl: './pplus-table-range-cell-renderer.component.html',
  styleUrls: ['./pplus-table-range-cell-renderer.component.scss']
})
export class PplusTableRangeCellRendererComponent implements ICellRendererAngularComp {

  params: any;
  editActive = false;

  constructor() { }
  refresh(params: any): boolean {
    //TODO
    return false;
  }
  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    //TODO
  }

  toggle() {
      this.params.node.setExpanded(!this.params.node.expanded);
  }

}


